import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-contact="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initContact()
    }

    function initContact() {
        const textarea = document.querySelector("textarea");

        function setHeight(elem) {
            const style = getComputedStyle(elem, null);
            const verticalBorders = Math.round(parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
            const maxHeight = parseFloat(style.maxHeight) || 300;
            
            elem.style.height = "auto";

            const newHeight = elem.scrollHeight + verticalBorders;
            
            elem.style.overflowY = newHeight > maxHeight ? "auto" : "hidden";
            elem.style.height = Math.min(newHeight, maxHeight) + "px";
            }

            textarea.addEventListener("input", (e) => {
            setHeight(e.target);
        });

        if(textarea){
            setHeight(textarea);
        }
    }

    return Object.freeze({
        init,
    })
}